<template>

  <v-container fluid v-if="transactions">

    <im-page-title
      title="Listă Tranzacții"
    />

    <im-transaction-tool
      :query.sync="query"
      @create="goToCreate"
    />

    <div class="ma-3">
      <v-progress-linear
        :indeterminate="querying"
        :color="querying ? 'primary' : 'grey'"
        rounded
      />
    </div>

    <im-transaction-list
      :transactions="transactions"
      :pagination.sync="pagination"
      @edit="goToEdit"
    />

  </v-container>

  <v-container v-else fluid class="fill-height">
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate color="primary"/>
    </v-row>
  </v-container>

</template>

<script>

  import transaction_repository from '@/repositories/transaction-repository';

  export default {

    components: {
      'im-page-title': () => import('@/components/ThePageTitle'),
      'im-transaction-tool': () => import('@/components/Transaction/TransactionToolbar'),
      'im-transaction-list': () => import('@/components/Transaction/TransactionList')
    },

    data: () => ({
      transactions: null,
      query: null,
      querying: false,
      pagination: {size: 10, page: 1}
    }),

    watch: {
      query: {
        handler: 'fetchTransactionsDebounced',
        immediate: true
      },
      pagination: {
        handler: 'fetchTransactions',
        immediate: false
      }
    },

    methods: {

      fetchTransactionsDebounced: _.debounce(function () {
        this.pagination.page = 1;
        this.fetchTransactions()
      }, 300),

      async fetchTransactions() {
        try {
          this.querying = true;
          this.transactions = await transaction_repository.getTransactions(this.query, this.pagination, {});
        } catch (e) {
          await this.$store.dispatch('alert/error', e)
        } finally {
          this.querying = false;
        }
      },

      goToCreate() {
        this.$router.push(`/transactions/create`);
      },

      goToEdit(transaction) {
        this.$router.push(`/transactions/${transaction.id}`);
      }

    }

  }

</script>